import AuthService from "./AuthService";

//const API_URL = "http://localhost:8081/api/patient/";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/patient/`;

class PatientService {
  getAll() {
    return fetch(API_URL, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }
  getPagedPatients(firstName, lastName, phone, page, pageSize) {
    // Pravimo Query parametre. Ako je vrednost prazna, ne šaljemo je.
    const params = new URLSearchParams();
    if (firstName) params.append("firstName", firstName);
    if (lastName) params.append("lastName", lastName);
    if (phone) params.append("phone", phone);
    params.append("page", page);
    params.append("pageSize", pageSize);

    return fetch(`${API_URL}paged?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška pri učitavanju: ${res.status} - ${text}`);
      }
      return res.json(); // Vraća PagedResult (data i totalCount)
    });
  }

  getPatientById(id) {
    return fetch(`${API_URL}${id}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  create(patient) {
    return fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(patient),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      const contentType = res.headers.get("Content-Type");
      return contentType && contentType.includes("application/json")
        ? res.json()
        : {};
    });
  }
  getPatientByPhone(phone) {
    return fetch(`${API_URL}phone/${phone}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }


  update(id, patient) {
    return fetch(`${API_URL}${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(patient),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }
      return res.json();
    });
  }

  delete(id) {
    return fetch(`${API_URL}${id}`, {
      method: "DELETE",
      headers: AuthService.getAuthHeader(),
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Greška: ${res.status}`);
      }
      if (res.status === 204) return null;
      const contentType = res.headers.get("Content-Type");
      return contentType && contentType.includes("application/json")
        ? res.json()
        : null;
    });
  }
}

export default new PatientService();
